/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiServerExceptionResponse,
  LoginResponse,
  PasswordResetResponse,
  PasswordResetSuccessResponse,
  StripePaymentDetails,
  SubscriptionUpgradeResponse,
  User,
  UserCreateRequest,
  UserModifiedResponse,
  UserUpdateRequest,
  WordPressSignupCreateRequest,
  WordPressSignupCreateResponse,
} from '../models/index';
import {
    ApiServerExceptionResponseFromJSON,
    ApiServerExceptionResponseToJSON,
    LoginResponseFromJSON,
    LoginResponseToJSON,
    PasswordResetResponseFromJSON,
    PasswordResetResponseToJSON,
    PasswordResetSuccessResponseFromJSON,
    PasswordResetSuccessResponseToJSON,
    StripePaymentDetailsFromJSON,
    StripePaymentDetailsToJSON,
    SubscriptionUpgradeResponseFromJSON,
    SubscriptionUpgradeResponseToJSON,
    UserFromJSON,
    UserToJSON,
    UserCreateRequestFromJSON,
    UserCreateRequestToJSON,
    UserModifiedResponseFromJSON,
    UserModifiedResponseToJSON,
    UserUpdateRequestFromJSON,
    UserUpdateRequestToJSON,
    WordPressSignupCreateRequestFromJSON,
    WordPressSignupCreateRequestToJSON,
    WordPressSignupCreateResponseFromJSON,
    WordPressSignupCreateResponseToJSON,
} from '../models/index';

export interface UserApiCreateUserRequest {
    userCreateRequest: UserCreateRequest;
}

export interface UserApiLoginRequest {
    email: string;
    password: string;
    remember?: boolean;
}

export interface UserApiRequestPasswordResetRequest {
    emailAddress: string;
}

export interface UserApiResetPasswordRequest {
    token: string;
    newPassword: string;
}

export interface UserApiSetStorageSettingsRequest {
    implementation: SetStorageSettingsImplementationEnum;
}

export interface UserApiUpdatePasswordRequest {
    currentPassword: string;
    newPassword: string;
}

export interface UserApiUpdateUserRequest {
    userUpdateRequest: UserUpdateRequest;
}

export interface UserApiUpgradeSubscriptionToYearlyRequest {
    subscriptionId: string;
}

export interface UserApiWordPressSignupRequest {
    wordPressSignupCreateRequest: WordPressSignupCreateRequest;
}

/**
 * 
 */
export class UserApi extends runtime.BaseAPI {

    /**
     * Create a new user from the provided properties. If no password is provided, one will be created internally. This can then be reset via a \'reset password\' request.
     * Create a new user.
     */
    async createUserRaw(requestParameters: UserApiCreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        if (requestParameters['userCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'userCreateRequest',
                'Required parameter "userCreateRequest" was null or undefined when calling createUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/user`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserCreateRequestToJSON(requestParameters['userCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Create a new user from the provided properties. If no password is provided, one will be created internally. This can then be reset via a \'reset password\' request.
     * Create a new user.
     */
    async createUser(requestParameters: UserApiCreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.createUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes the currently logged in `User
     */
    async deleteUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserModifiedResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/user`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserModifiedResponseFromJSON(jsonValue));
    }

    /**
     * Deletes the currently logged in `User
     */
    async deleteUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserModifiedResponse> {
        const response = await this.deleteUserRaw(initOverrides);
        return await response.value();
    }

    /**
     * Set the email opt-in to true for this `User`
     */
    async enableEmailOptInPreferenceRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserModifiedResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/user/emailPreference`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserModifiedResponseFromJSON(jsonValue));
    }

    /**
     * Set the email opt-in to true for this `User`
     */
    async enableEmailOptInPreference(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserModifiedResponse> {
        const response = await this.enableEmailOptInPreferenceRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns the Stripe payment details associated with the currently logged in user, including company name, billing address, tax IDs, and tax status.
     * Retrieve payment details for the current user.
     */
    async getStripeDetailsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripePaymentDetails>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/user/payment-details`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StripePaymentDetailsFromJSON(jsonValue));
    }

    /**
     * Returns the Stripe payment details associated with the currently logged in user, including company name, billing address, tax IDs, and tax status.
     * Retrieve payment details for the current user.
     */
    async getStripeDetails(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripePaymentDetails> {
        const response = await this.getStripeDetailsRaw(initOverrides);
        return await response.value();
    }

    /**
     * The user has to be logged in. The user can also be a chat agent (meaning it does not have `ROLE_USER`, but only a `ROLE_CHAT_AGENT`).
     * Retrieve the current (logged in) user.
     */
    async getUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/user`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * The user has to be logged in. The user can also be a chat agent (meaning it does not have `ROLE_USER`, but only a `ROLE_CHAT_AGENT`).
     * Retrieve the current (logged in) user.
     */
    async getUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.getUserRaw(initOverrides);
        return await response.value();
    }

    /**
     * Login the current user via a form.
     */
    async loginRaw(requestParameters: UserApiLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginResponse>> {
        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError(
                'email',
                'Required parameter "email" was null or undefined when calling login().'
            );
        }

        if (requestParameters['password'] == null) {
            throw new runtime.RequiredError(
                'password',
                'Required parameter "password" was null or undefined when calling login().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['email'] != null) {
            formParams.append('email', requestParameters['email'] as any);
        }

        if (requestParameters['password'] != null) {
            formParams.append('password', requestParameters['password'] as any);
        }

        if (requestParameters['remember'] != null) {
            formParams.append('remember', requestParameters['remember'] as any);
        }


        let urlPath = `/v1/session`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseFromJSON(jsonValue));
    }

    /**
     * Login the current user via a form.
     */
    async login(requestParameters: UserApiLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginResponse> {
        const response = await this.loginRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Logout.
     */
    async logoutRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/logout`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Logout.
     */
    async logout(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.logoutRaw(initOverrides);
        return await response.value();
    }

    /**
     * Set the email opt-in to false for this `User`
     */
    async removeEmailOptInPreferenceRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserModifiedResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/user/emailPreference`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserModifiedResponseFromJSON(jsonValue));
    }

    /**
     * Set the email opt-in to false for this `User`
     */
    async removeEmailOptInPreference(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserModifiedResponse> {
        const response = await this.removeEmailOptInPreferenceRaw(initOverrides);
        return await response.value();
    }

    /**
     * Allows a `User` to request a (short-lived) token. This will be send via e-mail.
     */
    async requestPasswordResetRaw(requestParameters: UserApiRequestPasswordResetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PasswordResetResponse>> {
        if (requestParameters['emailAddress'] == null) {
            throw new runtime.RequiredError(
                'emailAddress',
                'Required parameter "emailAddress" was null or undefined when calling requestPasswordReset().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['emailAddress'] != null) {
            queryParameters['emailAddress'] = requestParameters['emailAddress'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/user/password-reset`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PasswordResetResponseFromJSON(jsonValue));
    }

    /**
     * Allows a `User` to request a (short-lived) token. This will be send via e-mail.
     */
    async requestPasswordReset(requestParameters: UserApiRequestPasswordResetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PasswordResetResponse> {
        const response = await this.requestPasswordResetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Allows a `User` to reset their password via a (short-lived) token.
     */
    async resetPasswordRaw(requestParameters: UserApiResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PasswordResetSuccessResponse>> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling resetPassword().'
            );
        }

        if (requestParameters['newPassword'] == null) {
            throw new runtime.RequiredError(
                'newPassword',
                'Required parameter "newPassword" was null or undefined when calling resetPassword().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        if (requestParameters['newPassword'] != null) {
            queryParameters['newPassword'] = requestParameters['newPassword'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/user/password-reset`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PasswordResetSuccessResponseFromJSON(jsonValue));
    }

    /**
     * Allows a `User` to reset their password via a (short-lived) token.
     */
    async resetPassword(requestParameters: UserApiResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PasswordResetSuccessResponse> {
        const response = await this.resetPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Switch the user storage platform to a different one (either GCP (Google) or R2 (Cloudflare).
     */
    async setStorageSettingsRaw(requestParameters: UserApiSetStorageSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        if (requestParameters['implementation'] == null) {
            throw new runtime.RequiredError(
                'implementation',
                'Required parameter "implementation" was null or undefined when calling setStorageSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/user/settings/storage/{implementation}`;
        urlPath = urlPath.replace(`{${"implementation"}}`, encodeURIComponent(String(requestParameters['implementation'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Switch the user storage platform to a different one (either GCP (Google) or R2 (Cloudflare).
     */
    async setStorageSettings(requestParameters: UserApiSetStorageSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.setStorageSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the password for a logged in `User
     */
    async updatePasswordRaw(requestParameters: UserApiUpdatePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserModifiedResponse>> {
        if (requestParameters['currentPassword'] == null) {
            throw new runtime.RequiredError(
                'currentPassword',
                'Required parameter "currentPassword" was null or undefined when calling updatePassword().'
            );
        }

        if (requestParameters['newPassword'] == null) {
            throw new runtime.RequiredError(
                'newPassword',
                'Required parameter "newPassword" was null or undefined when calling updatePassword().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPassword'] != null) {
            queryParameters['currentPassword'] = requestParameters['currentPassword'];
        }

        if (requestParameters['newPassword'] != null) {
            queryParameters['newPassword'] = requestParameters['newPassword'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/user/update-password`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserModifiedResponseFromJSON(jsonValue));
    }

    /**
     * Update the password for a logged in `User
     */
    async updatePassword(requestParameters: UserApiUpdatePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserModifiedResponse> {
        const response = await this.updatePasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a user. Currently only `name` can be updated.
     */
    async updateUserRaw(requestParameters: UserApiUpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        if (requestParameters['userUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'userUpdateRequest',
                'Required parameter "userUpdateRequest" was null or undefined when calling updateUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/user`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UserUpdateRequestToJSON(requestParameters['userUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
    }

    /**
     * Update a user. Currently only `name` can be updated.
     */
    async updateUser(requestParameters: UserApiUpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.updateUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upgrades the specified subscription from a monthly billing cycle to a yearly billing cycle. The subscription must belong to the current user.
     * Upgrade a subscription from monthly to yearly billing
     */
    async upgradeSubscriptionToYearlyRaw(requestParameters: UserApiUpgradeSubscriptionToYearlyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionUpgradeResponse>> {
        if (requestParameters['subscriptionId'] == null) {
            throw new runtime.RequiredError(
                'subscriptionId',
                'Required parameter "subscriptionId" was null or undefined when calling upgradeSubscriptionToYearly().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2Scheme", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-cnb-api-key"] = await this.configuration.apiKey("x-cnb-api-key"); // apikeyScheme authentication
        }


        let urlPath = `/v1/user/subscription/{subscriptionId}/upgrade-to-yearly`;
        urlPath = urlPath.replace(`{${"subscriptionId"}}`, encodeURIComponent(String(requestParameters['subscriptionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionUpgradeResponseFromJSON(jsonValue));
    }

    /**
     * Upgrades the specified subscription from a monthly billing cycle to a yearly billing cycle. The subscription must belong to the current user.
     * Upgrade a subscription from monthly to yearly billing
     */
    async upgradeSubscriptionToYearly(requestParameters: UserApiUpgradeSubscriptionToYearlyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionUpgradeResponse> {
        const response = await this.upgradeSubscriptionToYearlyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a `User` from a WordPress signup.
     */
    async wordPressSignupRaw(requestParameters: UserApiWordPressSignupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WordPressSignupCreateResponse>> {
        if (requestParameters['wordPressSignupCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'wordPressSignupCreateRequest',
                'Required parameter "wordPressSignupCreateRequest" was null or undefined when calling wordPressSignup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/user/wp`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WordPressSignupCreateRequestToJSON(requestParameters['wordPressSignupCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WordPressSignupCreateResponseFromJSON(jsonValue));
    }

    /**
     * Create a `User` from a WordPress signup.
     */
    async wordPressSignup(requestParameters: UserApiWordPressSignupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WordPressSignupCreateResponse> {
        const response = await this.wordPressSignupRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const SetStorageSettingsImplementationEnum = {
    Gcs: 'GCS',
    R2: 'R2'
} as const;
export type SetStorageSettingsImplementationEnum = typeof SetStorageSettingsImplementationEnum[keyof typeof SetStorageSettingsImplementationEnum];
